module.exports = __webpack_public_path__ + "media/images/icon_popup_skill-fbc37d5a168732ab21f8a194a41d6bf5.png";